<template>
  <v-content>
    <v-card flat width="500" height="auto" style="position: relative">
      <v-hover
        v-slot:default="{ hover }"
        open-delay="50"
        style="cursor: pointer"
      >
        <!-- Size SM and Up -->
        <v-img
          v-if="$vuetify.breakpoint.smAndUp"
          aspect-ratio="1"
          :src="
            imageCover
              ? url + imgPath + 'images_cover/' + imageCover
              : require('../../assets/tcdc-color.png')
          "
          class="white--text"
          max-height="300"
          height="auto"
          :contain="imageCover ? false : true"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text pr-1 pt-1"
              style="height: 100%;"
            >
              <v-layout wrap class="justify-end">
                <v-flex xs12 class="d-flex justify-end  ma-1">
                  <v-btn
                    @click="onEdit()"
                    max-width="20"
                    max-height="20"
                    small
                    icon
                    color="green"
                  >
                    <v-icon color="#fff">mdi-pencil</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="d-flex justify-end ma-1">
                  <v-btn
                    @click="viewPortDetail(item)"
                    max-width="20"
                    max-height="20"
                    small
                    icon
                    color="green"
                  >
                    <v-icon color="#fff">mdi-eye</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="d-flex justify-end  ma-1">
                  <v-btn
                    @click="onDelete(item.portfolio_id)"
                    max-width="20"
                    max-height="20"
                    small
                    icon
                    color="green"
                  >
                    <v-icon color="#fff">mdi-delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-expand-transition>
        </v-img>

        <!-- Size mobile -->
        <v-img
          v-else
          :src="
            imageCover
              ? url + imgPath + 'images_cover/' + imageCover
              : require('../../assets/tcdc-color.png')
          "
          class="white--text align-end"
          aspect-ratio="1"
          max-height="430"
          height="auto"
          :contain="imageCover ? false : true"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              <div class="d-flex justify-end mx-3">
                <v-btn
                  @click="onEdit()"
                  max-width="20"
                  max-height="20"
                  small
                  icon
                  color="green"
                >
                  <v-icon large color="#fff">mdi-pencil</v-icon>
                </v-btn>
              </div>
              <div class="d-flex justify-end mx-3">
                <v-btn
                  @click="viewPortDetail(item)"
                  max-width="20"
                  max-height="20"
                  small
                  icon
                  color="green"
                >
                  <v-icon large color="#fff">mdi-eye</v-icon>
                </v-btn>
              </div>
              <div class="d-flex justify-end mx-3">
                <v-btn
                  @click="onDelete(item.portfolio_id)"
                  max-width="20"
                  max-height="20"
                  small
                  icon
                  color="green"
                >
                  <v-icon large color="#fff">mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-expand-transition>
        </v-img>
      </v-hover>

      <v-card-actions>
        <v-layout>
          <v-flex shrink class="d-flex align-center mr-3">
            <v-img
              v-if="$vuetify.breakpoint.smAndUp"
              style="border-radius: 100%"
              :src="
                imageProfile
                  ? url + imgPath + 'images_profile/' + imageProfile
                  : require('../../assets/user_profile.png')
              "
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              width="30px"
              height="30px"
            >
            </v-img>
            <v-img
              v-else
              style="border-radius: 100%"
              :src="
                imageProfile
                  ? url + imgPath + 'images_profile/' + imageProfile
                  : require('../../assets/user_profile.png')
              "
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              width="40px"
              height="40px"
            >
            </v-img>
          </v-flex>
          <v-flex>
            <v-layout>
              <v-flex>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.lgAndUp"
                  :style="{ 'font-size': fontLg + 'px' }"
                >
                  {{ title }}
                </div>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.md"
                  :style="{ 'font-size': fontMd + 'px' }"
                >
                  {{ title }}
                </div>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.smAndDown"
                  :style="{ 'font-size': fontSm + 'px' }"
                >
                  {{ title }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.lgAndUp"
                  :style="{ 'font-size': fontLg - 2 + 'px' }"
                >
                  {{ $t("by") }} {{ by ? checkName(by) : "" }}
                </div>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.md"
                  :style="{ 'font-size': fontMd - 1 + 'px' }"
                >
                  {{ $t("by") }} {{ by ? checkName(by) : "" }}
                </div>
                <div
                  class="one-line"
                  v-if="$vuetify.breakpoint.smAndDown"
                  :style="{ 'font-size': fontSm - 1 + 'px' }"
                >
                  {{ $t("by") }} {{ by ? checkName(by) : "" }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-content>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { domain, imgPath } from "../../services/Constants";

export default {
  components: {
    Loading,
  },
  name: "CardContent",
  props: {
    viewPortDetail: Function,
    onDelete: Function,
    item: null,
    title: {
      type: String,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    imageCover: {
      type: String,
    },
    imageProfile: {
      type: String,
    },
    by: {
      type: Object,
    },
    fontLg: {
      type: String,
      default: "11",
    },
    fontMd: {
      type: String,
      default: "11",
    },
    fontSm: {
      type: String,
      default: "13",
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    imgPath: imgPath,
    url: domain,
    dialog: false,
    // fullPage: true,
  }),
  methods: {
    onEdit() {
      this.$router.push({
        name: "EditPortfolio",
        params: { id: this.item.portfolio_id },
      });
    },

    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th;
        } else {
          return val.name_th + " " + val.last_th;
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en;
        } else {
          return val.name_en + " " + val.last_en;
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
  },
};
</script>

<style lang="scss">
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.65;
  position: absolute;
  width: 100%;
}

.v-responsive.v-image.img-content-cover {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.img-cover-by {
  border-radius: 100%;
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
